/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TaskComment } from './TaskComment';
import {
    TaskCommentFromJSON,
    TaskCommentFromJSONTyped,
    TaskCommentToJSON,
} from './TaskComment';

/**
 * 
 * @export
 * @interface PatientHandoverPatient
 */
export interface PatientHandoverPatient {
    /**
     * 
     * @type {string}
     * @memberof PatientHandoverPatient
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientHandoverPatient
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientHandoverPatient
     */
    assigned_to_id?: string;
    /**
     * 
     * @type {Array<TaskComment>}
     * @memberof PatientHandoverPatient
     */
    comments?: Array<TaskComment>;
}

/**
 * Check if a given object implements the PatientHandoverPatient interface.
 */
export function instanceOfPatientHandoverPatient(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PatientHandoverPatientFromJSON(json: any): PatientHandoverPatient {
    return PatientHandoverPatientFromJSONTyped(json, false);
}

export function PatientHandoverPatientFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientHandoverPatient {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'assigned_to_id': !exists(json, 'assigned_to_id') ? undefined : json['assigned_to_id'],
        'comments': !exists(json, 'comments') ? undefined : ((json['comments'] as Array<any>).map(TaskCommentFromJSON)),
    };
}

export function PatientHandoverPatientToJSON(value?: PatientHandoverPatient | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'description': value.description,
        'assigned_to_id': value.assigned_to_id,
        'comments': value.comments === undefined ? undefined : ((value.comments as Array<any>).map(TaskCommentToJSON)),
    };
}

